import * as React from 'react'
import { StoreProps, castingStoreGetTabsForOfferedServiceDescription } from '../../../../services/stores/casting.store'
import LightboxComponent from '../../../shared/lightbox.component'
import { DescriptionContainer, DescriptionTab, DescriptionParagraph } from '../casting-styled.component'
import IconPdf from '../../../../../../../iconFont/src/pdf.svg'

export default function CastingOfferedServiceDescriptionComponent ({ data, data: { market, offeredService } }: StoreProps) {
  const [currentTab, setCurrentTab] = React.useState<number>(null)
  const descriptionFile = offeredService.description_file || market.description_file
  const descriptionFilename = offeredService.description_filename || market.description_filename
  const tabs = React.useMemo(() => castingStoreGetTabsForOfferedServiceDescription(data), [data])

  React.useEffect(() => {
    if (!tabs.find(_ => _.value === currentTab)) {
      const newCurrentTab = tabs.length ? tabs[0].value : null
      if (newCurrentTab !== currentTab) setCurrentTab(newCurrentTab)
    }
  }, [currentTab, tabs])

  if (!tabs.length) return null
  
  return <DescriptionContainer>
    { tabs.length > 1 && <div style={{ display: 'flex' }}>
      { tabs.map(tab => <DescriptionTab key={ tab.value } onClick={ () => setCurrentTab(tab.value) } $active={ currentTab === tab.value }>{ tab.content }</DescriptionTab>) }
    </div> }

    { currentTab === 0 && <DescriptionParagraph>
      { offeredService.description && !offeredService.description_hide && <div dangerouslySetInnerHTML={{ __html: offeredService.description }} /> }

      { descriptionFile.url && <a href={ descriptionFile.url } target="_blank" rel="noopener noreferrer" className="u-mts" style={{ display: 'block' }}>
        <IconPdf height="2em" style={{ float: 'left', marginRight: '0.5em' }} /> { (descriptionFilename || '').replace(/_/g, ' ') }
      </a> }
    </DescriptionParagraph> }

    { currentTab === 1 && <DescriptionParagraph>
      <LightboxComponent imageUrls={ [offeredService.description_image.url] } />
    </DescriptionParagraph> }
  </DescriptionContainer>
}
